import Burger from 'mlmi-library/components/burger/v1/burger'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import '../plugins/fixed-header'

export default {
  burger: undefined,
  mobile: undefined,
  sleeping: false,
  status: {
    scrolled: false,
    fixed: false,
  },

  init() {
    let self = this,
    $body = $('body'),
    $app = $('.app'),
    $burger = $('.burger')

    /* Burger */
    let scrollTopBefore = 0, burgerTimeout = undefined
    this.burger = new Burger('.burger', {
      onToggle: function() {
        let windowHeight = window.innerHeight
        clearTimeout(burgerTimeout)
        if (self.burger.isExpanded) {
          $body.addClass('--menu-open')
          windowHeight = window.innerHeight
          burgerTimeout = setTimeout(function() {
            scrollTopBefore = $(window).scrollTop()
            $app.css({
              height: windowHeight + 'px',
              overflow: 'hidden',
            })
          }, 350)
        } else {
          $app.css({
            height: '',
            overflow: '',
          })
          $body.removeClass('--menu-open').scrollTop(scrollTopBefore)
        }
      },
    })

    /* Responsive toggler */
    this.mobile = new Mobile()
    this.mobile.addCallbacks(function() {
      /* Mobile */
      requestAnimationFrame(function() {
        $body.removeClass('--menu-open --header-fixed --header-visible --header-hidden')
      })
    }, function() {
      /* Desktop */
      requestAnimationFrame(function() {
        $body.removeClass('--menu-open --mobile-header-fixed --mobile-header-visible --mobile-header-hidden')
        $body.css({
          height: '',
          overflow: '',
        })
        $burger.attr('aria-expanded', 'false')
      })
    })

    /* Fixed header */
    $('.header').FixedHeader('header')
    $('.mobile-header').FixedHeader('mobile-header')
  }
}
